export const PositionCategoryTableTitle = [
    { label: 'ລຳດັບ' },
    { label: 'ອັງກິດ' },
    { label: 'ລາວ' },
    { label: 'ການຈັດການ' },
];